const ActionTypes = {
  SET_TOKEN: 'SET_TOKEN',
  SET_MESSAGE: 'SET_MESSAGE',
  SET_MOBILE_VERSION: 'SET_MOBILE_VERSION',
  SET_MOBILE2_URL: 'SET_MOBILE2_URL',
};
const ActionCreators = {
  setToken: token => ({ type: ActionTypes.SET_TOKEN, token }),
  setMessage: message => ({ type: ActionTypes.SET_MESSAGE, message }),
  setMobileVersion: mobileVersion => ({ type: ActionTypes.SET_MOBILE_VERSION, mobileVersion }),
  setMobile2Url: mobile2url => ({ type: ActionTypes.SET_MOBILE2_URL, mobile2url }),
};

export { ActionTypes, ActionCreators };

